/* Purpose: Top level navbar for any admin page
 * Props: 
 * Author: R. Markowitz (April 2025)
 * Dev Notes: 
*/
import { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { useLocation } from 'react-router-dom';

const AdminLayout = () => {
    const lightLogo = require("../Images/iskaLogo.png")

    const location = useLocation();
    const [currentLocation, setCurrentLocation] = useState(location.pathname.substring(8))
    useEffect(() => {
      setCurrentLocation(location.pathname)
    }, [location.pathname])
    

    return (
    <>
    <Navbar bg="dark" data-bs-theme="dark">
      <Container>
        <Navbar.Brand href="/">
                      <img
              src={lightLogo}
              width="100"
              height="40"
              className="d-inline-block align-top"
              alt="React Bootstrap logo"
            />
        </Navbar.Brand>
          <Nav className="me-auto">
            <Nav.Link className = "m5" href="/">{currentLocation == "" || currentLocation == "/"?<span className = 'current-location'>Home</span>:"Home"}</Nav.Link>
            <Nav.Link className = "m5" href={"/Admin"}>{currentLocation != "" && currentLocation != "/"?<span className = 'current-location'>Clients</span>:"Clients"}</Nav.Link>
          </Nav>
      </Container>
    </Navbar>
    </>      
    );
}

export default AdminLayout;